
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/password-changed",
      function () {
        return require("private-next-pages/password-changed.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/password-changed"])
      });
    }
  